<template>
  <OpDialog
    :title="title || $t('ifttt.selectObjects')"
    :visible="visible"
    :is-show-btn="false"
    @onClose="$emit('onClose')"
  >
    <div
      v-loading="isValidating"
      class="area-select"
    >
      <select-area
        :checkedarea="selectArea"
        class="limit_set"
        :areaid="gpNo"
        :area-self="false"
        :only-select-one="true"
        :filter-gp-no="true"
        @getarealist="setAreaList"
      />
      <div
        class="nextStep"
        :class="{ disabled: isValidating }"
        @click="onAreaOk"
      >
        {{ $t('limite.finsh') }}
      </div>
    </div>
  </OpDialog>
</template>

<script>
import OpDialog from '@/components/common/OpDialog';
import selectArea from '@/components/common/selectArea.vue';
import { validateCurrentRoom } from '../validateRoom.js';
import { alerterror } from '@/assets/js/common.js';

export default {
  name: 'OppleAreaSelectDialog',
  components: {
    OpDialog,
    selectArea
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gpNo: {
      type: Number,
      default: -1
    },
    title: {
      type: String,
      default: ''
    },
    device: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectArea: [],
      isValidating: false
    };
  },
  methods: {
    setAreaList(val) {
      this.selectArea = val;
    },
    async onAreaOk() {
      if (this.isValidating) return;

      if (!this.selectArea?.length) {
        this.$message.warning(this.$t('scene.blockOneSelect'));
        return;
      }

      const selectedArea = this.selectArea[0];
      this.isValidating = true;

      try {
        const passed = await validateCurrentRoom(this, selectedArea.id, this.device);

        if (!passed) return;

        this.$emit('onOk', {
          type: 'area',
          selectArea: selectedArea
        });
      } catch (e) {
        alerterror(this, e?.StatusCode || e);
      } finally {
        this.isValidating = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.area-select {
  .limit_left.limit_set {
    margin-top: 12px;
  }

  .nextStep {
    width: 76px;
    height: 31px;
    margin: 10px auto 20px;
    text-align: center;
    line-height: 31px;
    background-color: #0046aa;
    border-radius: 3px;
    border: solid 1px #0046aa;
    color: #fff;
    cursor: pointer;

    &.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
